import { render, staticRenderFns } from "./DropdownInput.vue?vue&type=template&id=be5d5928&scoped=true&"
import script from "./DropdownInput.vue?vue&type=script&lang=js&"
export * from "./DropdownInput.vue?vue&type=script&lang=js&"
import style0 from "./DropdownInput.vue?vue&type=style&index=0&id=be5d5928&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be5d5928",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
installComponents(component, {VAutocomplete})
